import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect () {
        const config = localStorage.getItem('hebgo-popup');
        let hideUntil = 0;
        let version = 1;

        if (config) {
            [version, hideUntil] = config.split('_', 2);
        }

        if (version !== 'v1') {
            hideUntil = 0;
        }

        if (hideUntil > Date.now()) {
            return;
        }

        this.element.showModal();
    }

    close () {
        this.element.close();
        localStorage.setItem('hebgo-popup', `v1_${Date.now() + 86400}`);
    }
}
